export default __webpack_public_path__ + "cccea97a1412ca686566a119dbcf5cdb.png";